import { ReactNode } from 'react';
import { Divider } from 'primereact/divider';
import { ReactComponent as Close } from '$icons/uncolored/Close.svg';
import { Button } from 'primereact/button';

const SPKShowcaseModalShell = ({
  title,
  onClose,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  showNavigation,
  children,
}: {
  title: string;
  onClose: () => void;
  onPrevious?: () => void;
  onNext?: () => void;
  hasPrevious?: boolean;
  hasNext?: boolean;
  showNavigation?: boolean;
  children: ReactNode;
}) => {
  return (
    <div className="flex flex-col bg-white rounded-2xl font-mulish max-h-[90vh] max-w-[90%] overflow-hidden min-w-[60%]">
      <div className="flex py-2 pr-2 pl-[2px] justify-between items-center self-stretch">
        {showNavigation ? (
          <div className="flex">
            <Button
              label="< Previous"
              onClick={onPrevious}
              disabled={!hasPrevious}
              severity="success"
              size="small"
              text
            />
            <Button
              label="Next >"
              onClick={onNext}
              disabled={!hasNext}
              severity="success"
              size="small"
              text
            />
          </div>
        ) : (
          <div />
        )}
        <button type="button" onClick={onClose} className="p-2">
          <Close className="stroke-spk-mediumContrast" />
        </button>
      </div>
      <div className="flex p-6 flex-col items-start self-stretch overflow-y-auto bg-spk-neutral-20">
        <div className="text-spk-brightBlue text-base font-bold">{title}</div>
        <Divider className="w-full py-2" />
        {children}
      </div>
    </div>
  );
};

SPKShowcaseModalShell.defaultProps = {
  onPrevious: undefined,
  onNext: undefined,
  hasPrevious: false,
  hasNext: false,
  showNavigation: true,
};

export default SPKShowcaseModalShell;
